import { mapActions, mapMutations } from 'vuex'

export default {
  ...mapActions(['updateSettings']),
  ...mapMutations([
    'setSettingsNotifyToggle',
    'setSettingsNotifySendToggle',
    'setSettingsNotifyPushAppToggle',
    'setSettingsNotifyPushWebToggle',
    'setSettingsNotifyDependentToggle',
    'setSettingsDependetsPsush'
  ]),
  doToogleNotifySettings (key) {
    this.setSettingsNotifyToggle(key)
    this.updateSettings()
  },
  doToogleNotifySendSettings (key) {
    this.setSettingsNotifySendToggle(key)
    this.updateSettings()
  },
  doToogleNotifyPushAppSettings () {
    this.setSettingsNotifyPushAppToggle()
    this.updateSettings()
  },
  doToogleNotifyPushWebSettings () {
    this.setSettingsNotifyPushWebToggle()
    this.updateSettings()
  },
  // ativando notificações para deependes, mais precisar ser adcionado dependentes
  doToogleNotifyDependentsSettings () {
    this.setSettingsNotifyDependentToggle()
    this.updateSettings()
  },
  // adcionando dependentes para receber notificações, mais precisa esta
  // com o paramentro ativo.
  doPushNotifyDependentsSettings (dependent) {
    if (dependent !== 'undefined') {
      this.setSettingsDependetsPsush(dependent)
      this.updateSettings()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/config/resources/methods.js